<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="danger"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_SHOP_DEL && scope.row.isDisabled == 'NO'"
                               @click.stop="handleProhibit(scope.row,'YES')">禁用店铺
                    </el-button>
                    <el-button type="success"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_SHOP_DEL && scope.row.isDisabled == 'YES'"
                               @click.stop="handleProhibit(scope.row,'NO')">启用店铺
                    </el-button>
                </template>
                <template slot-scope="scope"
                          slot="imgUrl">
                    <viewer :images="formmaterImage(scope.row.imgUrl)" >
                        <img v-for="src in formmaterImage(scope.row.imgUrl)" :src="src" :key="src" width="20">
                    </viewer>
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import { licenseTableOption } from "@/const/salesCloud/licenseOption";
    import { findLicense, prohibitLicense } from "@/api/salesCloud/license"
    import {DIC} from "@/const/dic"

    export default {
        name: "license",
        components: {},
        data() {
            return {
                tableOption: licenseTableOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                formDialog: false,
                tabelObj: {},
                oneForm: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                }
            };
        },
        created() {
            this.handleList();

        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            handleProhibit(row,option){
                this.$confirm(`是否确认此项操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let obj = {
                            option: option,
                        }
                        prohibitLicense(row.id, obj).then(response => {
                            if (response.code == '200') {
                                this.$message({
                                    showClose: true,
                                    message: "操作成功",
                                    type: "success"
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error"
                                })
                            }

                        }).catch(error => {
                            this.loading = false
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error"
                            })
                        })
                    })
                    .catch(() => {
                    });
            },
            formmaterImage(row){
                let str = new Array();
                    str.push(row)
                return str
            },
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findLicense(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findLicense(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findLicense(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findLicense(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findLicense(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    console.log(data,1111);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
                done();
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {

            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {
            }
        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
